import React from "react";
import DataList from "components/datatable/DataList";
import { getStrDateLong, postgresDateToIndonesia } from "utils/MyUtils";
import { boolText, showEmpty } from "features/kms/system/SystemPageUtils";

function formatDate(value) {
  return value ? postgresDateToIndonesia(value) || getStrDateLong(value) : "";
}

function formatPeriod(item) {
  const start = formatDate(item?.tanggal_mulai);
  const end = item?.tanggal_selesai ? formatDate(item.tanggal_selesai) : "Sekarang";
  return `${start || "-"} s.d. ${end || "Sekarang"}`;
}

export default function PersonalMembershipHistoryPage() {
  const coltype = {
    peran_name: {
      label: "Peran",
      renderFunc: (val) => showEmpty(val),
      width: 120,
    },
    nomor_induk: {
      label: "No. Induk",
      renderFunc: (val) => showEmpty(val),
      width: 130,
      align: "center",
    },
    cabor_name: {
      label: "Cabor",
      renderFunc: (val) => showEmpty(val),
      width: 160,
    },
    induk_organisasi_cabor_name: {
      label: "Induk Organisasi Cabor",
      renderFunc: (val) => showEmpty(val),
      width: 180,
    },
    klub_olahraga_name: {
      label: "Klub Olahraga",
      renderFunc: (val) => showEmpty(val),
      width: 180,
    },
    periode: {
      label: "Periode",
      renderFunc: (val, col, item) => showEmpty(formatPeriod(item)),
      renderExportFunc: (val, col, item) => showEmpty(formatPeriod(item)),
      width: 210,
      align: "center",
    },
    aktif: {
      label: "Status",
      renderFunc: (val) => boolText(val),
      renderExportFunc: (val) => boolText(val),
      width: 90,
      align: "center",
    },
  };

  return (
    <DataList
      title="Keanggotaan"
      coltype={coltype}
      dlist={{
        url: "/profile/keanggotaan",
        columns: [
          "no",
          "peran_name",
          "nomor_induk",
          "cabor_name",
          "induk_organisasi_cabor_name",
          "klub_olahraga_name",
          "periode",
          "aktif",
        ],
        filter: [{ dtype: "q", name: "q", colsize: 12 }],
        sort_by: [
          "peran_name",
          "nomor_induk",
          "cabor_name",
          "induk_organisasi_cabor_name",
          "klub_olahraga_name",
          "tanggal_mulai",
          "tanggal_selesai",
        ],
      }}
      pdflist={{ title: "Keanggotaan" }}
      xlslist={{ title: "Keanggotaan" }}
    />
  );
}
